module.exports = __webpack_public_path__ + "static/img/slide3_w.11fbd5b.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/img/caroussel/slide3_w.jpeg
// module id = xCgF
// module chunks = 1